import { toMoney } from './transformations';
function escapeHtml(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
function parseHtml(html) {
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    return tpl.content.firstElementChild;
}
/**
 * Mirrors product-price-v2.liquid in compact cart context
 * (mode: 'compact', show_percentage_saved: false, show_price_disclaimer: false).
 * Prices are in cents.
 *
 * Keep in sync with src/snippets/product-price-v2.liquid.
 * Tests in template-renderers.spec.ts compare this output against the Liquid-rendered snippet
 * and will fail if the two drift.
 */
export function renderProductPriceCompact({ regularPrice, salePrice, subMessage, productId }) {
    const currencySymbol = window?.UNTUCKitConfig?.cartCurrencySymbol;
    const regularPriceMoney = toMoney(regularPrice, currencySymbol, true);
    const hasSale = salePrice > 0 && regularPrice > salePrice;
    const productIdAttr = productId ? ` data-product-id="${productId}"` : '';
    const salePriceHtml = hasSale ? (() => {
        const salePriceMoney = toMoney(salePrice, currencySymbol, true);
        return `<div class="product-price-v2__sale-price">
      <span class="product-price-v2__money" aria-label="sale price ${salePriceMoney}">${salePriceMoney}</span>
    </div>`;
    })() : '';
    const subMessageHtml = subMessage
        ? `<p class="product-price-v2__sub-message">${escapeHtml(subMessage)}</p>`
        : '';
    return parseHtml(`<div class="product-price-v2__container product-price-v2__container--compact"${productIdAttr}>
  <div class="product-price-v2__price-container">
    <div class="product-price-v2__regular-price${hasSale ? ' product-price-v2__regular-price--on-sale' : ''}">
      <span class="product-price-v2__money" aria-label="regular price ${regularPriceMoney}">${regularPriceMoney}</span>
    </div>
    ${salePriceHtml}
  </div>
  ${subMessageHtml}
</div>`);
}
/**
 * Mirrors product-color-display-value.liquid.
 * Priority: metafields.global.style → options_by_name['color'].values[0] → 'description:' tag.
 *
 * Tests in template-renderers.spec.ts compare this output against the Liquid-rendered snippet.
 */
export function renderProductColorDisplayValue(product) {
    let colorDisplayValue = product.metafields?.global?.style ?? product.options_by_name?.['color']?.values?.[0];
    for (const tag of product.tags) {
        if (tag.toLowerCase().includes('description:')) {
            colorDisplayValue = tag.split(':').pop().trim();
            break;
        }
    }
    return colorDisplayValue ?? '';
}
/**
 * Mirrors product-badge.liquid for the social proof case where labelText is always provided.
 *
 * Keep in sync with src/snippets/product-badge.liquid.
 * Tests in template-renderers.spec.ts compare this output against the Liquid-rendered snippet.
 */
export function renderProductBadgeSimple({ labelText, labelStyleClass, iconUrl }) {
    const hasIcon = !!iconUrl;
    const iconHtml = hasIcon
        ? `<img class="product-badge-v2__icon" src="${escapeHtml(iconUrl)}" aria-hidden="true" height="24" width="24" /> `
        : '';
    return parseHtml(`<div class="product-badge-v2__container product-badge-v2__container--${escapeHtml(labelStyleClass)}${hasIcon ? ' product-badge-v2__container--has-icon' : ''}">
  <span class="product-badge-v2__text">${iconHtml}${escapeHtml(labelText)}</span>
</div>`);
}
